import React, { useState } from 'react';
import AdultDrugCalculator from '../calculator/AdultDrugCalculator';
import PediatricDrugCalculator from '../calculator/PediatricDrugCalculator';
import { FIRELINE_MEDIC_BADGE } from '../brand/firelineMedicBadge';
import './drugcalc-public.css';

export default function DrugCalcPublic() {
  const [mode, setMode] = useState('adult');

  return (
    <div className="drugcalc-public-page">
      <main className="drugcalc-public-shell">
        <header className="drugcalc-public-header">
          <div className="drugcalc-public-brand">
            <img src={FIRELINE_MEDIC_BADGE} alt="Line Medic" />
            <div>
              <span>LINE MEDIC · FIELD MEDICATION TOOL</span>
              <h1>Drug Calculator</h1>
              <p>Adult and Sacramento County 9000-series pediatric medication calculations.</p>
            </div>
          </div>
          <div className="drugcalc-public-badge">FIELD REFERENCE</div>
        </header>

        <div className="drugcalc-public-alert">
          <strong>Calculation aid only.</strong>
          <span>Confirm the patient, indication, medication, concentration, route, dose limits, and current official protocol before administration.</span>
        </div>

        <nav className="drugcalc-public-tabs" aria-label="Calculator population">
          <button type="button" className={mode === 'adult' ? 'is-active' : ''} onClick={() => setMode('adult')}>
            <span>ADULT</span>
            Adult Calculator
          </button>
          <button type="button" className={mode === 'peds' ? 'is-active' : ''} onClick={() => setMode('peds')}>
            <span>PEDIATRIC</span>
            9000-Series Calculator
          </button>
        </nav>

        <section className="drugcalc-public-content">
          {mode === 'adult' ? <AdultDrugCalculator /> : <PediatricDrugCalculator />}
        </section>
      </main>
    </div>
  );
}
